<template>
  <div class="chart-component" v-loading="chartLoading">
    <div ref="chartRef" class="chart-content" :style="chartHeight ? { height: `${chartHeight}px` } : {}"></div>
    <div class="legend-content" v-show="legendData.length > 0 && !byDownload" v-if="false">
      <div class="legend-item single-ellipsis" v-for="(item, index) in legendData" :key="index">
        <div class="tip-content" :style="fetchBgStyle(index)"></div>
        <span class="legend-text">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import chartComponent from './mixins/chart-component';

export default {
  mixins: [chartComponent],
  data() {
    return {
      legendData: []
    };
  },
  computed: {
    chartType() {
      return 'pieChart';
    }
  },
  methods: {
    async initDataHandle(params) {
      const { originData } = params;
      const { rowsData, columnsData, chartConfig } = originData;
      const { fontSize = 12 } = chartConfig;

      const seriesDataItem = {
        name: '',
        type: 'pie',
        data: []
      };

      if (rowsData.length > 0) {
        if (params.rows.length <= 1) {
          seriesDataItem.name = rowsData[0].name;
          seriesDataItem.data = rowsData[0].data.map((dataVal, dataIndex) => {
            return { value: dataVal, name: columnsData[dataIndex] };
          });
        } else {
          seriesDataItem.name = 'pie';
          seriesDataItem.data = rowsData.map(dataVal => {
            return { value: dataVal.data[0], name: dataVal.name };
          });
        }
      }

      const refreshData = {
        type: this.chartType,
        isChart: true,
        config: {
          tooltip: {
            confine: true,
            trigger: 'item',
            formatter: val => {
              if (isNaN(val.value)) {
                return val.name;
              }
              return `${val.name}(${val.value.toLocaleString()}个/${val.percent}%)`;
            }
          },
          label: {
            fontSize,
            color: this.chartTextColor,
            formatter: val => {
              return `${val.name}(${val.value.toLocaleString()}个/${val.percent}%)`;
            }
          },
          emphasis: {
            label: { fontSize: Math.ceil(fontSize * 1.2), fontWeight: 'bold', color: this.chartTextColor }
          },
          legend: {
            show: false,
            orient: 'vertical',
            right: '20px',
            top: 'center'
          },
          series: [seriesDataItem]
        }
      };

      this.legendData = [...columnsData];

      return refreshData;
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-component {
  position: relative;
  width: 100%;
  height: 100%;

  .chart-content {
    width: 100%;
    height: 100%;
  }

  .legend-content {
    box-sizing: border-box;
    position: absolute;
    top: 30px;
    bottom: 30px;
    right: 20px;
    width: 140px;
    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .legend-item {
      width: 100%;
      height: 30px;
      line-height: 30px;
      .tip-content {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #ccc;
        margin-right: 6px;
        border-radius: 50%;
      }
      .legend-text {
        color: #3d465a;
        font-size: 14px;
      }
    }
  }
}
</style>
